export const environment = {
  production: true,
  api: "https://toba-api-live.vitale.digital/",
  // api: 'http://localhost:5000/'
};
